export default __webpack_public_path__ + "static/media/37.9e7ff2a2.jpg";